import React, { useEffect, useRef, useState } from 'react';
import './AnimatedSection.css';

export default function AnimatedSection({ children, className = '' }) {
  const [isVisible, setVisible] = useState(false);
  const domRef = useRef();

  useEffect(() => {
    const currentRef = domRef.current;
    const observer = new IntersectionObserver(entries => {
      entries.forEach(entry => {
        if (entry.isIntersecting) {
          setVisible(true);
          // Unobserve once it becomes visible so it doesn't animate out and in again
          observer.unobserve(entry.target);
        }
      });
    }, { threshold: 0.15 }); // Triggers when 15% of the element is visible

    if (currentRef) {
      observer.observe(currentRef);
    }
    
    return () => {
      if (currentRef) observer.unobserve(currentRef);
    };
  }, []);

  return (
    <div
      className={`fade-in-section ${isVisible ? 'is-visible' : ''} ${className}`}
      ref={domRef}
    >
      {children}
    </div>
  );
}